// extracted by mini-css-extract-plugin
module.exports = {"container":"G4q9XN","content":"_1uvamX","closeIcon":"_2N-F1U","subTitle":"_15nq5u","shine-lines":"_1p3tNW"};